import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import { Button } from '@/components/Button/Button'
import { Label, LabelIcon } from '@/components/EventHeading/styles'
import { ScrollbarContainer } from '@/components/Scrollbar/styles'
import { stageGradient } from '@/constants/icons'

export const ContentUnavailableWrapper = styled.div`
  height: calc(100% - 360px);
  margin-right: 112px;
`

export const ContentWrapper = styled.div`
  margin: 0px 0px 0px 224px;
`

export const HomeTabPageMainLayout = styled(FocusNode)`
  position: relative;
  width: 100%;
  height: 100%;

  /* .isFocused {
    outline: 1px dashed rgba(0, 255, 0, 0.5);
  }

  .isFocusedLeaf {
    outline: 1px dashed gold;
  } */
`

export const HomeTabPageHeaderLayout = styled(FocusNode)<{
  $isHidden?: boolean
}>`
  position: relative;
  display: flex;
  height: 148px;
  padding: 54px 350px 54px 0;
  margin-bottom: 32px;
  z-index: 1;

  transition: opacity 0.3s;
  opacity: 1;
  ${({ $isHidden }) =>
    $isHidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`
export const HeaderLogo = styled.img`
  position: absolute;
  top: 54px;
  right: 90px;
  width: 140px;
  object-fit: contain;
`
export const HomeTabPageTabsLayout = styled(FocusNode)`
  display: flex;
  position: relative;
  z-index: 1;
`

export const HomeTabPageTabElem = styled(FocusNode)`
  cursor: pointer;
  font-size: 40px;
  line-height: 1;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.2);
  text-transform: uppercase;
  margin: 0 16px;
  position: relative;
  transition: color 0.3s ease;
  will-change: opacity, color;
  &:first-of-type {
    margin-left: 0;
  }
  &.isActiveTab {
    color: rgba(255, 255, 255, 1);
  }
  &.isFocused,
  &.isFocused.isActiveTab {
    color: ${(props) => props.theme.colors.accent};
  }
`

export const HomeTabPageTabActiveLine = styled.div`
  position: absolute;
  bottom: -3px;
  left: 0;
  height: 3px;
  background: ${(props) => props.theme.colors.accent};
  transition: transform 0.3s ease, width 0.3s ease;
  margin-left: 0;
  border-radius: 3px;
`

export const HomeTabPageLinesContainer = styled(FocusNode)<{
  $isVisible: boolean
  $isHidden: boolean
}>`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 900px;
  transform: translateY(-290px);
  opacity: 1;
  transition: transform 0.3s ease-in, opacity 0.3s;

  &.isFocused {
    transform: translateY(-900px);
    transition: transform 0.3s ease-out;
  }

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      transform: translateY(-900px);
      transition: transform 0.3s ease-out;
    `}

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`

export const HomeTabPageLinesContainerBg = styled.div`
  position: absolute;
  top: 200px;
  left: 0;
  width: 100%;
  height: calc(100% - 200px);
  background: rgb(31, 66, 88);
  &:before {
    content: '';
    position: absolute;
    bottom: 100%;
    width: 100%;
    height: 200px;
    background: linear-gradient(
      to bottom,
      rgba(31, 66, 88, 0),
      rgba(31, 66, 88, 1)
    );
  }
`

export const StageContainer = styled(FocusNode)<{
  $isFullscreen?: boolean
  $isVisible: boolean
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 0;
  transform: translateY(-250px);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      transform: translateY(0);
      transition: opacity 0.3s ease-in, transform 0.3s ease-in;
    `}

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      z-index: 1;
    `};

  &.isFocused ${ScrollbarContainer} li.is-active {
    background-color: ${(props) => props.theme.colors.accent};
  }
`

export const StageForeground = styled(ContentWrapper)`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  transform: translateY(200px);
`

export const StageBackgroundContainer = styled.div<{
  $isFaded?: boolean
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-position: 50% 50%;
    object-fit: contain;
    background-color: #111;
  }
`

export const StageBackgroundContainerFader = styled.div<{ $isFaded?: boolean }>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: url(${stageGradient}) 0 0 no-repeat transparent;
  background-size: cover;
  pointer-events: none;
  transition: opacity 1s;
  opacity: ${({ $isFaded }) => ($isFaded ? '1' : '0')};
`

export const StageTilesGroup = styled(FocusNode)`
  display: flex;
  flex: 0 1 500px;
  position: relative;
  margin-bottom: 20px;
  /* background-color: red; */
  /* mix-blend-mode: difference; */
`

export const StageTileEl = styled(FocusNode)<{
  $withAnimation: boolean
  $visibilityStatus: string
}>`
  display: flex;
  height: 100%;
  flex-direction: column;
  font-size: 24px;
  line-height: 1.2;
  width: 50%;
  font-weight: 400;
  position: absolute;
  transform: scale(1) translateX(0);
  transform-origin: 25% 50%;
  opacity: 1;

  ${({ $withAnimation }) =>
    $withAnimation &&
    css`
      transition: opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s;
    `}

  ${({ $visibilityStatus }) =>
    $visibilityStatus === 'isBefore' &&
    css`
      opacity: 0;
      transform: scale(1) translateX(-150px);
      pointer-events: none;
    `}

    ${({ $visibilityStatus, $withAnimation }) =>
    $withAnimation &&
    $visibilityStatus === 'isBefore' &&
    css`
      transition: opacity 0.5s ease 0s, transform 0.5s ease 0s;
    `}

  ${({ $visibilityStatus }) =>
    $visibilityStatus === 'isAfter' &&
    css`
      opacity: 0;
      transform: scale(1) translateX(150px);
      pointer-events: none;
    `}

    ${({ $visibilityStatus, $withAnimation }) =>
    $withAnimation &&
    $visibilityStatus === 'isAfter' &&
    css`
      transition: opacity 0.5s ease 0s, transform 0.5s ease 0s;
    `}
`

export const TokensContainer = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 27px;

  font-weight: 700;
  font-size: 20px;
  line-height: 100%;

  text-transform: uppercase;
  > img {
    margin-left: 12px;
    height: 33px;
  }
`

export const StageTileHeader = styled.header`
  display: flex;
  font-size: 48px;
  height: 2.3em;
  line-height: 1.15;
  text-transform: uppercase;
  max-width: 70%;
  margin-bottom: 2rem;
  font-weight: 600;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const StageTileContent = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-weight: 500;
  margin-bottom: 2rem;
`

export const StageTileFooter = styled.footer`
  position: absolute;
  bottom: 0;
  left: 0;
  flex-direction: column;
  width: 100%;
  display: flex;
  flex: 0 1 auto;
  justify-content: space-between;
  & > button {
    margin: 16px 0 0;
  }
`

export const StageTileFooterRow = styled.div`
  display: flex;
`

export const StageFooter = styled.footer`
  display: flex;
  justify-content: center;
  margin-right: 88px;
`

export const SecondaryTileButton = styled(Button)`
  margin-left: 16px;
`

export const StageBadges = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.4rem;
  ${Label} {
    height: 26px;
    margin: 10px 1rem 10px 0px;
    line-height: 26px;
    font-size: 16px;
    border-radius: 13px;
  }
  ${LabelIcon} {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }
`
export const ChannelLogoWrapper = styled.div`
  margin-right: 8px;
`
export const ChannelLogo = styled.img`
  max-width: 114px;
  height: 46px;
  object-fit: contain;
`

export const PromotionLogo = styled.img`
  height: 40px;
  margin-bottom: 40px;
`

export const StageVideoContainer = styled(FocusNode)<{
  $isFullscreen?: boolean
}>`
  width: 100%;
  height: 100%;
  /* background-color: cyan; */
  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      position: fixed;
      z-index: 12;
      background-color: #000;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    `}
`
